import React, { useContext, useState } from "react";
import styles from './ModalCancelAccessToData.module.css'
import { HashLoader } from "react-spinners";
import * as patientApi from '../../../service/patientApiDev'
import { CurrentUserContext } from "../../../App"
import { RedirectCode400 } from "../../RedirectCode400"
import { useNavigate } from "react-router-dom"


export default function ModalCancelAccessToDataV2({ onClose, data, onClickData }) {

    // const {
    //     setIsMessage
    // } = useContext(CurrentUserContext)
    // const navigate = useNavigate()

    // const [loading, setLoading] = useState(false)

    // const acceptCredentialToken = async (permission_id, accept, every_time, some_time) => {
    //     setLoading(true)
    //     let res = await patientApi.acceptCredentialToken(permission_id, accept, every_time, some_time)
    //     setLoading(false)

    //     if (res) {
    //         if (res['data']['code'] === 200) {
    //             setIsMessage(res['data']['message_th'] || res['data']['message'])
    //             onClose()
    //         } else if (res['data']['code'] === 403) {
    //             navigate(RedirectCode400())
    //         } else {
    //             console.log(res['data']['message_th'] || res['data']['message'])
    //         }
    //     } else {
    //         setIsMessage('เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่')
    //     }
    // }

    return (
        <div className="z-[99] fixed flex top-0 right-0 w-full h-full justify-center items-center bg-[#0000008f]">
            {/* <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" /> */}
            <div className="w-[600px] bg-white rounded-md">
                <div className="flex justify-end mt-[10px] mr-[10px]">
                    <img className="w-7 h-7 cursor-pointer" onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img>
                </div>
                <div className="-mt-5 p-7">
                    <div className='w-full text-2xl font-bold text-center'>
                        ยกเลิกสิทธิ์การเข้าถึงข้อมูล
                    </div>
                    <div className='text-center text-base font-bold pb-5'>
                        <div>{data['doctor']['pname'] + data['doctor']['fname'] + ' ' + data['doctor']['lname']}</div>
                        <div>{data['doctor']['hospital']['hospital_name']}</div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', gridGap: 20 }}>
                        <button
                            onClick={() => { onClose() }}
                            className="px-5 py-2 text-blue-500 bg-white rounded-md">
                            ปิด
                        </button>
                        <button
                            onClick={() => { onClickData(data['permission_id'], false, false, false) }}
                            className="px-5 py-2 text-white bg-blue-500 rounded-md border-blue-500 border">
                            ยกเลิกสิทธิ์
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}